<template>
    <div class="category-manager">
        <div class="btn-box">
            <a-button @click="showAdd">添加分類</a-button>
        </div>
        <a-table :data-source="list" row-key="id">
            <a-table-column
                    align="center"
                    title="分類ID"
                    data-index="id">
            </a-table-column>
            <a-table-column
                    align="center"
                    title="分類名稱"
                    data-index="categoryName">
            </a-table-column>
            <a-table-column
                    align="center"
                    title="添加時間">
                <template slot-scope="row,item">
                    {{item.addTime | trans-date}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="排序">
                <template slot-scope="row,item">
                    <a-input style="width:100px;text-align: center;" placeholder="排序" v-model="item.sortNum" @blur="changeSort(item)"></a-input>
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="操作">
                <template slot-scope="row,item">
                    <a-button type="link" @click="del(item)">刪除</a-button>
                    <a-button type="link" @click="edit(item)">編輯</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-modal
                :width="700"
                v-model="addShow"
                :title="addMsg"
                @cancel="addCancel"
                :confirmLoading="subLoading"
                @ok="subHandle">
            <a-form>
                <a-form-item
                        label="分類名稱"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                ><a-input placeholder="請輸入分類名稱" v-model="categoryName"></a-input></a-form-item>
                <a-form-item
                        label="分類排序"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                ><a-input placeholder="請輸入分類排序" v-model="sort"></a-input></a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list:[],
                addShow:false,
                addMsg:'添加分類',
                subLoading:false,
                categoryName:undefined,
                editType:false,
                sort:undefined,
                loading:false,
                editId:undefined
            }
        },
        methods: {
            showAdd(){
                this.addShow=true;
            },
            addCancel(){
                this.addShow=false;
                this.addMsg='添加分類'
                this.categoryName=undefined;
                this.editType=false;
                this.sort=undefined;
                this.editId=undefined;
            },
            edit(item){
                this.editType=true;
                this.addMsg='編輯分類';
                this.editId=item.id;
                this.categoryName=item.categoryName;
                this.sort=item.sortNum;
                this.addShow=true;
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '確定要刪除出該條數據嗎？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/product/category/delete',
                                data:self.qs.stringify({
                                    id:item.id
                                }),
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(res=>{
                                self.$Message.success('操作成功');
                                self.getList();
                                resolve();
                            }).catch(err=>{
                                reject()
                            })
                        })
                    },
                    onCancel() {},
                });
            },
            changeSort(item){
                let self=this;
                self.$http({
                    method: 'post',
                    url: '/manager/product/category/update',
                    data:{
                        categoryName:item.categoryName,
                        sortNum:item.sortNum,
                        id:item.id
                    }
                }).then(res=>{
                    self.$Message.success('操作成功');
                    self.getList();
                }).catch(err=>{
                    self.$Message.error(JSON.stringify(err))
                })
            },
            subHandle(){
                let self=this;
                if(this.categoryName === '' || !this.categoryName){
                    this.$Message.warning('請輸入分類名稱');
                    return false;
                }
                if (this.sort === '' || !this.sort){
                    this.$Message.warning('請輸入分類排序');
                    return false;
                }
                let data={
                    categoryName:self.categoryName,
                    sortNum:self.sort
                };
                let url;
                if(this.editType){
                    data.id=this.editId;
                    url='/manager/product/category/update'
                }else{
                    url='/manager/product/category/add'
                    delete data.id;
                }
                self.subLoading=true;
                self.$http({
                    method: 'post',
                    url: url,
                    data:data
                }).then(res=>{
                    self.$Message.success('操作成功');
                    self.getList()
                    self.subLoading=false;
                    self.addCancel();
                }).catch(err=>{
                    self.$Message.error(JSON.stringify(err))
                    self.subLoading=false;
                })
            },
            getList(){
                let self=this;
                self.$http({
                    method: 'get',
                    url: '/manager/product/category/list',
                }).then(res=>{
                    self.list=res.data ? res.data : []
                })
            }
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['商品管理','商品分類管理'])
        },
    }
</script>
<style lang="less">
    .category-manager{
        .btn-box{
            text-align: left;
            margin-bottom:20px;
        }
    }
</style>